<template>
    <div>
        <breadcrumbs
            :title="'Vrste skupova'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Vrsta skupa: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <vrsta-skupa-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                ></vrsta-skupa-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaSkupaForma from "./VrstaSkupaForma";
export default {
    name: "VrstaSkupaEdit",
    components: {
        VrstaSkupaForma,
        Breadcrumbs,
    },
    data(){
        return {
            id: this.$route.params.vrsta_skupa_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-skupova',
                    name: 'Vrste skupova'
                },
                {
                    path: '/postavke/vrste-skupova/' + this.id,
                    name: 'Vrsta skupa: ' + this.naziv
                },
                {
                    path: '/postavke/vrste-skupova/' + this.id + '/edit',
                    name: 'Uredi vrstu skupa: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
